import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import softwareDetailsActions from '../actions/softwareDetails';
import businessModelActions from '../actions/businessModel';
import {isPPM} from '../utils/validate';
import {DEEP_LINK_PARAM_TYPE, removeDeepLinkParams} from '../utils/localStorageDataHandler';

const dispatchServiceError = (store, errorKey) => {
    store.dispatch(softwareDetailsActions.alertError(errorKey));
    store.dispatch(actions.enableLoadOverLay(false));
};

function submitSoftwareDetails(store, action) {
    const softwareDetails = action.payload.softwareDetails;
    request.post(`/${config.url_prefix}/api/advertiser`)
        .send({
            data: softwareDetails
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                const errorKey = 'ipmob.internal.server.error';
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(softwareDetailsActions.alertError(errorKey));
            } else if (response.statusCode === 204) {
                const userType = store.getState().app.userType;
                if (isPPM(userType)) {
                    store.dispatch(actions.changeAppState('CURRENCY_DETAILS'));
                } else if (store.getState().app.dyff?.SHARED_IPM_BANKING_ENABLED) {
                    store.dispatch(businessModelActions.getPreferredBusinessModel(softwareDetails.systemId, userType));
                } else {
                    removeDeepLinkParams(DEEP_LINK_PARAM_TYPE.pmscParams); // remove PMSC params from local storage
                    removeDeepLinkParams(DEEP_LINK_PARAM_TYPE.ulxParams); // remove ULX params from local storage
                    store.dispatch(actions.changeAppState('MAILING_INFORMATION'));
                }
            } else {
                try {
                    const parsedResponse = response.text ? JSON.parse(response.text) : {};
                    if (parsedResponse.code === 400) {
                        dispatchServiceError(store, 'ipmob.software_details.invalid');
                    } else {
                        dispatchServiceError(store, 'ipmob.error.process.request');
                    }
                } catch (e) {
                    dispatchServiceError(store, 'ipmob.error.process.request');
                }
            }
        });
}

export default submitSoftwareDetails;
